import { z } from "zod";
import {
  CHECK,
  CLEARING_AMOUNT,
  COMMUNITY_ID,
  DOC_DATE,
  DOC_NO,
  DOC_TYPE,
  DOCUMENT_TYPE,
  DRCR,
  DUE_DATE,
  GL_ACCOUNT,
  LINE_ITEM_ID,
  LINE_ITEMS,
  OWNERSHIP_ID,
  PAY_BLOCK,
  PAYMENT_METHOD,
  PROPERTY_ID,
  REMARK,
  SMALL_VARIANCE_GL,
  VARIANCE_AMT,
  LINE_ITEM_TYPE
} from "./consts";

export const schema = z.object({
  [DOCUMENT_TYPE]: z.string().optional(),
  [SMALL_VARIANCE_GL]: z.string().optional(),
  [VARIANCE_AMT]: z.string().optional(),
  [PROPERTY_ID]: z.string().optional(),
  [OWNERSHIP_ID]: z.string().optional(),
  [REMARK]: z.string().optional(),
  [COMMUNITY_ID]: z.string().optional(),
  [LINE_ITEMS]: z
    .object({
      [CHECK]: z.boolean().optional(),
      [LINE_ITEM_ID]: z.string().optional(),
      [GL_ACCOUNT]: z.string().optional(),
      [DOC_DATE]: z.string().optional(),
      [DOC_NO]: z.string().optional(),
      [DOC_TYPE]: z.string().optional(),
      [DUE_DATE]: z.string().optional(),
      [PAYMENT_METHOD]: z.string().optional(),
      [CLEARING_AMOUNT]: z.string().optional(),
      [PAY_BLOCK]: z.string().optional(),
      [DRCR]: z.string().optional(),
      [LINE_ITEM_TYPE]: z.string().optional(),
    })
    .array(),
});

export type formValues = z.infer<typeof schema>;
